import React from "react";
import InputField from "../../../../components/InputField";
import DocumentUpload from "../../../../components/DocumentUpload";
import "./index.scss";

const MSMESection = ({
  isMSMERegistered,
  formData,
  errors,
  handleChange,
  handleBlur,
  msmeFile,
  handleMsmeFileChange,
}) => {
  if (isMSMERegistered !== "yes") return null;

  return (
    <div className="msme-section">
      <div className="msme-section__row">
        <InputField
          name="msmeNumber"
          label="MSME Registration Number"
          type="text"
          placeholder="Enter MSME number"
          value={formData.msmeNumber || ""}
          maxLength={19}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.msmeNumber}
          required
        />
        <DocumentUpload
          label="MSME Certificate"
          name="msmeDocument"
          file={msmeFile}
          onChange={(e) => handleMsmeFileChange(e.target.files[0])}
          required
        />
      </div>
    </div>
  );
};

export default MSMESection;
